/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-sample-item-status.reducer';

export const DiaglabSampleItemStatusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabSampleItemStatusEntity = useAppSelector(state => state.diaglabSampleItemStatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabSampleItemStatusDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.detail.title">DiaglabSampleItemStatus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.id}</dd>
          <dt>
            <span id="statusEvent">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.statusEvent">Status Event</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.statusEvent}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.timestampEntry}</dd>
          <dt>
            <span id="eventDate">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.eventDate">Event Date</Translate>
            </span>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.eventDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.diaglabSampleItem">Diaglab Sample Item</Translate>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.diaglabSampleItem ? diaglabSampleItemStatusEntity.diaglabSampleItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItemStatus.collector">Collector</Translate>
          </dt>
          <dd>{diaglabSampleItemStatusEntity.collector ? diaglabSampleItemStatusEntity.collector.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-sample-item-status" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-sample-item-status/${diaglabSampleItemStatusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabSampleItemStatusDetail;
